import { useCallback, useMemo } from "react"

import { useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useMapDispatchContext } from "@l2r-front/l2r-map"
import { RoadDetailInfo, useNetworksDispatchContext } from "@l2r-front/l2r-networks"
import { BottomSheetContent, Typography, useIsMobileDevice } from "@l2r-front/l2r-ui"
import { useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"

import { SpeedingsGrades } from "../SpeedingsGrades"
import { SpeedLimitsSelector } from "../SpeedLimitsSelector"
import { TrafficSelector } from "../TrafficSelector"

import * as Styled from "./SpeedingsSidebar.styled"

export function SpeedingsSidebar() {

    const { t } = useTranslation(I18N_NAMESPACE)
    const { road } = useParams()
    const { setRoadSearched } = useNetworksDispatchContext()
    const { setMapPin } = useMapDispatchContext()
    const navigate = useNavigateWithSearchParams()
    const isMobile = useIsMobileDevice()

    const navigateBack = useCallback(() => {
        setRoadSearched(null)
        setMapPin()
        navigate("..")
    }, [navigate, setRoadSearched, setMapPin])

    const michelinLogoComponent = useMemo(() => {
        return !road ? <Styled.Wrapper>
            <Styled.Label variant="Desktop & Mobile/Body/Label & Helper text">
                {t(I18N_NAMESPACE, "containers.speedingsSidebar.partnership")}
            </Styled.Label>
            <Styled.Logo src="assets/resources/michelin.png" />
        </Styled.Wrapper> : null
    }, [road, t])

    return (
        <BottomSheetContent
            id="speedings-sidebar"
            onBack={road ? navigateBack : null}
            title={t(I18N_NAMESPACE, `containers.speedingsSidebar.${road ? "roadTitle" : "title"}`)}
            titleBottomComponent={michelinLogoComponent}
        >
            <Styled.Container isMobile={isMobile}>
                <Styled.ContentWrapper>
                    {road && <RoadDetailInfo isMobile={isMobile} road={road} />}
                    <SpeedingsGrades />
                    <Typography variant="Desktop & Mobile/Heading/H2">{t(I18N_NAMESPACE, "containers.speedLimitsSelector.title")}</Typography>
                    <SpeedLimitsSelector />
                    <Typography variant="Desktop & Mobile/Heading/H2">{t(I18N_NAMESPACE, "containers.trafficSelector.title")}</Typography>
                    <TrafficSelector />
                </Styled.ContentWrapper>
            </Styled.Container>
        </BottomSheetContent>
    )
}